import { useEffect } from "react";
import { inject } from "../../../lib/itn-ui-kit/services/service-container";
import {useNavigate} from "react-router-dom";

export default () => {
  const ringCentralService = inject('ring-central-service');
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const code = new URLSearchParams(window.location.search).get('code');
      if (code) {
        try {
          await ringCentralService.exchangeCodeForToken(code);
          navigate("/dashboard?offset=0&limit=100&overall_status__in=Active%2CActive+-+Client+Unresponsive%2CActive+-+Paused+%28See+Note%29%2CActive+-+Waiting+on+Limits");
        } catch (error) {
          debugger
          console.error('OAuth token exchange failed:', error);
        }
      }
    };

    handleOAuthCallback();
  }, []);

  return 'sgljsdlgkjdsg';
};
